import { create } from 'zustand';
import type { AdminUser } from '@affogato/shared';

interface AdminState {
  users: AdminUser[];
  isLoading: boolean;
  selectedUser: AdminUser | null;
  searchQuery: string;

  // Actions
  setUsers: (users: AdminUser[]) => void;
  setIsLoading: (loading: boolean) => void;
  setSelectedUser: (user: AdminUser | null) => void;
  setSearchQuery: (query: string) => void;
  updateUserInList: (userId: string, updates: Partial<AdminUser>) => void;
  addUserToList: (user: AdminUser) => void;
}

export const useAdminStore = create<AdminState>((set) => ({
  users: [],
  isLoading: false,
  selectedUser: null,
  searchQuery: '',

  setUsers: (users) => set({ users }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setSelectedUser: (selectedUser) => set({ selectedUser }),
  setSearchQuery: (searchQuery) => set({ searchQuery }),

  updateUserInList: (userId, updates) =>
    set((state) => ({
      users: state.users.map((user) =>
        user.id === userId ? { ...user, ...updates } : user
      ),
      selectedUser:
        state.selectedUser?.id === userId
          ? { ...state.selectedUser, ...updates }
          : state.selectedUser,
    })),

  addUserToList: (user) =>
    set((state) => ({
      users: [user, ...state.users],
    })),
}));

// Selector for filtered users
export const useFilteredUsers = () =>
  useAdminStore((state) => {
    const query = state.searchQuery.toLowerCase();
    if (!query) return state.users;

    return state.users.filter(
      (user) =>
        user.email.toLowerCase().includes(query) ||
        user.name.toLowerCase().includes(query)
    );
  });
